import { Component, Inject, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';

export interface IInputConfirmationFormControls {
  inputValue :FormControl<string>;
}

@Component({
  selector: 'lum-input-ui-confirmation-dialog',
  templateUrl: './ui-input-confirmation-dialog.component.html',
  styleUrls: ['./ui-input-confirmation-dialog.component.scss'],
})
export class UiInputConfirmationDialogComponent implements OnInit {
  form :FormGroup<IInputConfirmationFormControls>;

  #comparator :(value :string) => boolean;
  #targetValue :string;

  constructor(
    private _fb :FormBuilder,
    public dialogRef :MatDialogRef<UiInputConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data :{
      deleteButtonText ?:string;
      isCaseSensitive ?:boolean;
      message ?:string;
      title ?:string;
      value :string;
    },
  ) {}

  ngOnInit() :void {
    this.#initComparison();
    this.form = this._fb.group({
      inputValue: new FormControl<string>('', [
        Validators.required,
        this.#buildNameValidator(),
      ]),
    });

    this.data.deleteButtonText ||= 'Delete';
    this.data.isCaseSensitive ??= false;
    this.data.message ||= this.#buildDefaultMessage();
    this.data.title ||= this.#buildDefaultTitle();
  }

  onSubmit(e :Event) :void {
    e.preventDefault();

    this.dialogRef.close(this.form.valid);
  }

  #buildDefaultMessage() :string {
    return `To confirm, enter "${this.#targetValue}" in the text field below.`;
  }
  #buildDefaultTitle() :string {
    return `Delete ${this.data.value}?`;
  }

  #buildNameValidator() :ValidatorFn {
    return (control :AbstractControl) :{ [key :string] :any } | null => {
      const { value } = control;

      return this.#comparator(value) ? null : { targetNotMatched: { value } };
    };
  }

  #initComparison() {
    this.#targetValue = this.data.isCaseSensitive
      ? this.data.value
      : this.data.value.toUpperCase();

    // we keep the ternary _outside_ the function so that we don't have to check
    // the `isCaseSensitive` value every time the input changes
    this.#comparator = this.data.isCaseSensitive
      ? (value :string) => value === this.#targetValue
      : (value :string) => value.toUpperCase() === this.#targetValue;
  }
}
